import React from "react";
import Table from "./ServiceTable";
import { Container } from "@material-ui/core";
import {  Col, Input } from "reactstrap";
import { Card, CardTitle } from "reactstrap";
import axios from "axios";
import base_URL from "../base_URL";

import data from "../stateData";

import { Row } from "reactstrap";



class Details extends React.Component {
  constructor() {
    super();
    let id = JSON.parse(localStorage.getItem("token"));
    this.state = {
      input: {
        state: "0",
        city: "0",
        theme: "0",
      },
      theme: [],
      states: data,
      State: "",
      city: [],
      id,
      rows: [],
      table: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  handleChange(event) {
  
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({
      input,
    });

    let row;
    let state1 = this.state.input.state;
    let city = this.state.input.city;
    let theme = this.state.input.theme;

    if (theme == "0") {
      row = this.state.rows;
      if (state1 != "0") {
        row = this.state.rows.filter((r) => r.state == state1);

        if (city != "0") {
          row = row.filter((r) => r.city == city);
        }
      }
    } else {
      row = this.state.rows.filter((r) => r.theme == theme);

      if (state1 != "0") {
        row = row.filter((r) => r.state == state1);

        if (city != "0") {
          row = row.filter((r) => r.city == city);
        }
      }
    }

   
    this.setState({
      table: row,
    });
  }

  changeState(e) {
    let input = this.state.input;
    input[e.target.name] = e.target.value;
   
    input["city"] = "0";

    if (e.target.value == "0") {
      this.setState({
        city: [],
        input: input,
      });
    } else {
      this.setState({
        city: this.state.states.find((c) => c.state == e.target.value)
          .districts,
        input: input,
      });
    }

    this.handleChange(e);
  }

  componentDidMount() {
    axios
      .get(`${base_URL}/theme/all`)

      .then(
        (response) => {
          this.setState({ theme: response.data });
        },
        (error) => {}
      );

    axios.get(`${base_URL}/Service/get`).then((response) =>
      this.setState({
        rows: response.data,
        table: response.data,
      })
    );
  }

  render() {
    return (
      <Container  id="container">
        <Card body style={{ margin: "20px" }} id="Card">
        <CardTitle>
            <h1>Service Provider Details</h1>
          </CardTitle>
            <form>
              <Row>
                <Col xs={12} md={4}>
                  <div class="form-group">
                    <label for="theme">Service Type</label>
                    <Input
                      type="select"
                      name="theme"
                      value={this.state.input.theme}
                      onChange={this.handleChange}
                      className="form-control"
                      placeholder="Service Type"
                      id="theme"
                    >
                      <option value="0">Select Theme</option>
                      {this.state.theme.map((item, id) => {
                        return (
                          <option key={id} value={item.themeName}>
                            {item.themeName}
                          </option>
                        );
                      })}
                    </Input>
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <div class="form-group">
                    <label for="state">State</label>
                    <Input
                      type="select"
                      name="state"
                      value={this.state.input.state}
                      onChange={this.changeState}
                      class="form-control"
                      id="state"
                    >
                      <option value="0">Select State</option>
                      {this.state.states.map((item, id) => {
                        return <option key={id}>{item.state}</option>;
                      })}
                    </Input>
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <div class="form-group">
                    <label for="city">City</label>
                    <Input
                      type="select"
                      name="city"
                      value={this.state.input.city}
                      onChange={this.handleChange}
                      class="form-control"
                      id="city"
                    >
                      <option value="0">Select city</option>
                      {this.state.city.map((c,id) => {
                        return <option value={c} key={id}>{c}</option>;
                      })}
                    </Input>
                  </div>
                </Col>
              </Row>
            </form>
           
        
        </Card>
        <Table data={this.state.table}/>

       
      </ Container>
    );
  }
}
export default Details;
